import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Car, Trophy, Ticket, Megaphone, ArrowRight, Calendar } from "lucide-react";
import { endpoints } from "@/lib/api";
import StayTuned from "@/components/StayTuned";

export default function AppHome() {
  const [event, setEvent] = useState(null);
  const [ann, setAnn] = useState([]);
  const [cars, setCars] = useState([]);

  useEffect(() => {
    endpoints.event().then(setEvent).catch(() => {});
    endpoints.announcements().then(setAnn).catch(() => {});
    endpoints.cars().then((c) => setCars(c.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <div className="relative overflow-hidden border border-white/10" data-testid="app-hero">
        {event?.hero_poster && <img src={event.hero_poster} alt="" className="w-full h-40 object-cover opacity-40" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f11] to-transparent" />
        <div className="absolute inset-0 p-4 flex flex-col justify-end">
          <div className="font-heading uppercase text-xs text-[#ff7a1a]">Welcome to</div>
          <div className="pas-wordmark text-3xl"><span className="pas-gradient-text">Perth</span> <span className="text-white">Auto Salon</span></div>
        </div>
      </div>

      <div className="border border-white/10 bg-[#121212] p-4" data-testid="app-countdown">
        <div className="flex items-center gap-2 text-[#8a8d91] font-heading uppercase text-xs mb-3"><Calendar size={13} /> Main event 2027</div>
        <StayTuned />
      </div>

      <div className="grid grid-cols-3 gap-3">
        {[
          { to: "/app/cars", icon: Car, label: "Vote" },
          { to: "/app/leaderboard", icon: Trophy, label: "Leaderboard" },
          { to: "/app/tickets", icon: Ticket, label: "Tickets" },
        ].map((q) => (
          <Link key={q.to} to={q.to} className="border border-white/10 bg-[#121212] p-4 grid place-items-center gap-2 card-hover" data-testid={`quick-${q.label.toLowerCase()}`}>
            <q.icon className="text-[#ff7a1a]" size={22} />
            <span className="font-heading uppercase text-xs text-white">{q.label}</span>
          </Link>
        ))}
      </div>

      {ann.length > 0 && (
        <div>
          <div className="flex items-center gap-2 font-heading uppercase text-sm text-white mb-3"><Megaphone size={16} className="text-[#b026ff]" /> Announcements</div>
          <div className="space-y-2">
            {ann.slice(0, 3).map((a) => (
              <div key={a.id} className="border-l-2 border-[#b026ff] bg-[#121212] px-4 py-3" data-testid="announcement">
                <div className="font-heading text-white uppercase text-sm">{a.title}</div>
                <div className="text-[#8a8d91] text-sm font-body">{a.body}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <div className="flex items-center justify-between mb-3">
          <span className="font-heading uppercase text-sm text-white">Feature builds</span>
          <Link to="/app/cars" className="text-[#ff7a1a] text-xs font-heading uppercase flex items-center gap-1">All cars <ArrowRight size={12} /></Link>
        </div>
        <div className="space-y-3">
          {cars.map((c) => (
            <Link key={c.id} to={`/app/cars/${c.id}`} className="flex gap-3 border border-white/10 bg-[#121212] card-hover overflow-hidden">
              <img src={c.photo_url} alt="" className="w-28 h-24 object-cover" />
              <div className="py-3 pr-3">
                <div className="text-[#ff7a1a] font-heading text-xs uppercase">{c.year} · {c.category_name}</div>
                <div className="font-heading text-white uppercase leading-tight">{c.make} {c.model}</div>
                <div className="text-[#8a8d91] text-xs mt-1 flex items-center gap-1"><Trophy size={11} /> {c.vote_count} votes</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
